/**
 * Gibt eine Size-Formatierungsfunktion für einen Ruler zurück
 */
export default function simpleSizeFormatter (settings=STAGE.settings.ruler) {
    return (size) => I18N.formatFloat(size*settings.scale,settings.fixed) + ' ' + settings.unit;
}